const state = {
  components: []
}

const options = {
  root: null,
  rootMargin: '0px',
  threshold: 0.01,
};

const cacheComponents = () => {
  const mediaWrappers = Array.from(document.querySelectorAll('.hub-video__media-wrapper'));

  state.components = mediaWrappers.reduce((components, wrapper) => {
    const id = wrapper.dataset.overlayId;
    const video = wrapper.querySelector('[data-component="video"]');
    const controllers = wrapper.querySelectorAll('[data-component="controller"]');

    if (video && controllers.length) {
      return [...components, { wrapper, id, video, controllers, wasAudioMuted: true, wasPlaying: true}]
    }
    return components
  }, [])
}

const addEventListeners = () => {
  state.components.forEach(component => {
    component.controllers.forEach(controller => {
      controller.addEventListener('click', toggleVideo.bind(component))
    })

    component.video.addEventListener('play', onVideoStateChange.bind(component))
    component.video.addEventListener('pause', onVideoStateChange.bind(component))
    component.video.addEventListener('volumechange', onVideoVolumeChange.bind(component))
    window.addEventListener("resize", setVideoBackground);
  })

  document.addEventListener('overlay:close', () => {
    state.components.forEach(component => {
      component.video.pause();
    })
  })
  document.addEventListener('overlay:open', (e) => {
    const triggerId = e?.detail?.id;
    if (!triggerId) return;
    state.components.forEach(component => {
      if (component.id !== e?.detail?.id) {
        component.video.pause();
      } else {
        component.video.play();
      }
    })
  })
}

function toggleVideo (e) {
  const icon = e.target.closest('.Icon');
  const action = icon?.dataset?.action;

  switch (action) {
    case "play":
      this.video.play();
      break
    case "pause": 
      this.video.pause();
      break
    case "unmute":
      this.video.muted = false;
      break
    case "mute": 
      this.video.muted = true;
      break
  }
}

function setVideoBackground() {
  const isMobile = window.matchMedia('(max-width: 769px)').matches;
  state.components.forEach(component => {
      const { video } = component;
      if (!video) return;
      const paused = video.paused;
      const currentSrc = video.src;
      const newSrc = isMobile ? video.dataset.srcMobile : video.dataset.srcDesktop;
      if (currentSrc === newSrc) return;
      video.src = newSrc;
      if (paused) {
        video.pause()
      } else {
        video.play()
      }
  })
}

function onVideoStateChange () {
  this.wrapper.dataset.playing = !this.video.paused;
}

function onVideoVolumeChange () {
  this.wrapper.dataset.volume = this.video.muted ? false : Boolean(this.video.volume);
}

function attachIntersectionObserver() {
  state.components.forEach(component => {
      const { video, wrapper } = component;
      if (!video) return;

      const observer = new IntersectionObserver((e) => {
        if (!e[0].isIntersecting) {
            component.wasPlaying = !video.paused;
            component.wasAudioMuted = video.muted;

            video.pause();
            wrapper.dataset.playing = false;
            return;
        }

        video.muted = component.wasAudioMuted;
        if (!component.wasPlaying) return;

        video.play();
        wrapper.dataset.volume = !component.wasAudioMuted;
      }, options);
      observer.observe(video);
  })
}

const init = () => {
  cacheComponents();
  addEventListeners();
  setVideoBackground();
  attachIntersectionObserver();
}

export default init;